<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.875 2.5021C8.36871 2.50896 8.06477 2.53827 7.81901 2.66349C7.53677 2.8073 7.3073 3.03677 7.16349 3.31901C7.03827 3.56477 7.00896 3.86871 7.0021 4.375M15.625 2.5021C16.1313 2.50896 16.4352 2.53827 16.681 2.66349C16.9632 2.8073 17.1927 3.03677 17.3365 3.31901C17.4617 3.56477 17.491 3.86871 17.4979 4.37499M17.4979 11.125C17.491 11.6313 17.4617 11.9352 17.3365 12.181C17.1927 12.4632 16.9632 12.6927 16.681 12.8365C16.4352 12.9617 16.1313 12.991 15.625 12.9979M17.5 6.99999V8.49999M11.5 2.5H13M4.9 17.5H10.6C11.4401 17.5 11.8601 17.5 12.181 17.3365C12.4632 17.1927 12.6927 16.9632 12.8365 16.681C13 16.3601 13 15.9401 13 15.1V9.4C13 8.55992 13 8.13988 12.8365 7.81901C12.6927 7.53677 12.4632 7.3073 12.181 7.16349C11.8601 7 11.4401 7 10.6 7H4.9C4.05992 7 3.63988 7 3.31901 7.16349C3.03677 7.3073 2.8073 7.53677 2.66349 7.81901C2.5 8.13988 2.5 8.55992 2.5 9.4V15.1C2.5 15.9401 2.5 16.3601 2.66349 16.681C2.8073 16.9632 3.03677 17.1927 3.31901 17.3365C3.63988 17.5 4.05992 17.5 4.9 17.5Z"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
